import { TableSummaryRow } from './row';
import { TableSummaryCell } from './cell';
export * from './context';
export var Summary = {
  Row: TableSummaryRow,
  Cell: TableSummaryCell
};